// SPDX-License-Identifier: MIT
// Shared per-project sync badge for the unified card header. Web → neutral "in the
// cloud". Desktop → synced/syncing/untied, with a humanised relative time appended
// for the "synced" state only (when a lastSyncedAt is known).
//
// Locale note: uses getBundleLocale() (same source of truth as t()) rather than
// detectLocale() so both label and timeAgo stay in sync in all environments.
import { t, getBundleLocale } from '../i18n/t';
import { timeAgo } from '../lib/time-ago';
import type { SyncStatus } from '../platform/sync-status';

export interface SyncBadgeOptions {
  platform: 'web' | 'desktop';
  status: SyncStatus;
  lastSyncedAt?: string | null;
  now?: number; // injectable for tests
}

export function renderSyncBadge(opts: SyncBadgeOptions): HTMLElement {
  const el = document.createElement('span');
  el.className = 'sync-badge';
  el.setAttribute('data-component', 'sync-badge');
  el.setAttribute('data-sync-status', opts.status);
  let label = t(`syncBadge.${opts.status}`);
  if (opts.status === 'synced') {
    const ago = timeAgo(opts.lastSyncedAt, getBundleLocale(), opts.now);
    if (ago) label = `${label} · ${ago}`;
  }
  el.textContent = label;
  return el;
}
